import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, ArrowRight, Baby, Rocket, Briefcase, Wand2 } from "lucide-react";
import { CinematicVideo } from "@/components/CinematicVideo";

const ACADEMIE_VIDEO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_epiphany-mentor/artifacts/92xv8hl1_gemini_generated_video_dfa75a35.mp4";

const PILLS = [
  { Icon: Baby, label: "Junior · 8–12" },
  { Icon: Rocket, label: "Ado · 13–17" },
  { Icon: Briefcase, label: "Adulte / Pro · 18+" },
];

export function AcademieCard() {
  return (
    <section className="relative px-6 my-20" data-testid="academie-card">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-[2rem] overflow-hidden border border-primary/20 frame-pulse glass">
          <div aria-hidden className="absolute inset-0 pointer-events-none">
            <div className="absolute right-0 top-0 w-[420px] h-[420px] rounded-full bg-primary/10 blur-[120px]" />
          </div>
          <div className="relative z-10 px-6 sm:px-12 py-14 text-center">
            <div className="max-w-2xl mx-auto mb-10">
              <CinematicVideo
                silver
                src={ACADEMIE_VIDEO}
                testId="academie-cinematic-video"
                caption="Chlorophylle — L'Académie de l'IA"
                fade
                noSound
              />
            </div>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/15 border border-primary/40 text-primary text-[11px] uppercase tracking-[0.28em] mb-6" data-testid="academie-card-eyebrow">
              <GraduationCap size={13} /> L'Académie de l'IA
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
              className="font-display text-gradient-orange text-4xl sm:text-6xl leading-[1.12] pb-[0.08em] mb-4" data-testid="academie-card-title"
            >
              Chlorophylle
            </motion.h2>
            <p className="text-foreground/70 text-base sm:text-lg max-w-xl mx-auto leading-relaxed mb-8">
              Comme la chlorophylle capte la lumière pour faire grandir la plante, apprends à <span className="text-primary">capter l'IA</span> pour faire grandir ton esprit. Des parcours interactifs par âge : comprendre, créer, et garder l'esprit critique.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 max-w-sm sm:max-w-2xl mx-auto mb-9">
              {PILLS.map((p) => (
                <span key={p.label} className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/12 bg-white/[0.03] px-4 py-3 text-sm text-foreground/70">
                  <p.Icon size={15} className="text-primary/80" /> {p.label}
                </span>
              ))}
            </div>

            <Link to="/academie-ia" data-testid="academie-card-cta" className="btn-frost-orange group inline-flex items-center gap-3 px-8 py-4 rounded-full font-semibold text-base sm:text-lg">
              <Wand2 size={18} /> Entrer dans l'Académie
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
